import React, { useState, useEffect } from "react";
import { fetchJson } from "../../lib/Fetching";
import styled, { css } from "styled-components";

const Item = ({ active, onClick, name }) => (
  <li className={active ? "active" : ""}>
    <a onClick={onClick} href="#" style={{ marginBottom: 0 }}>
      {name}
    </a>
  </li>
);

export default function SuiteCategoryPicker({ company_id, onChange }) {
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [suiteCategories, setSuiteCategories] = useState([]);

  const updateCategory = id => {
    setSelectedCategoryId(id);
    onChange && onChange(id);
  };

  useEffect(() => {
    fetchJson("/products/suite_categories/", { company_id }).then(json => {
      setSuiteCategories(json.suite_categories);
    });
  }, []);

  if (suiteCategories.length == 0) return null;

  return (
    <ul className="nav nav-pills" style={{ marginTop: 20 }}>
      <Item
        active={selectedCategoryId == null}
        name="All Products"
        onClick={() => updateCategory(null)}
      />
      {suiteCategories.map(sc => (
        <Item
          key={sc.id}
          active={selectedCategoryId === sc.id}
          name={sc.name}
          onClick={() => updateCategory(sc.id)}
        />
      ))}
    </ul>
  );
}
